import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import {useTranslation} from "react-i18next";

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & { children: React.ReactElement<any, any> },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

type AlertDialogSlideProps = {
    title: React.ReactNode;
    message: React.ReactNode;
    openAlert: boolean;
    action: string;
    onClose: (result: 'yes' | 'no' | 'dismiss', action: string) => void;
    yesLabel?: React.ReactNode;
    noLabel?: React.ReactNode;
};

export default function AlertDialogSlide({
                                             title,
                                             message,
                                             openAlert,
                                             onClose,
                                             action,
                                             yesLabel = '',
                                             noLabel = '',
                                         }: AlertDialogSlideProps) {
    const {t} = useTranslation();

    const handleRequestClose = (
        _event: object,
        reason: 'backdropClick' | 'escapeKeyDown',
    ) => {
        onClose('dismiss', action);
    };

    return (
        <Dialog
            open={openAlert}
            keepMounted
            TransitionComponent={Transition}
            onClose={handleRequestClose}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose(true, action)}>{yesLabel ? yesLabel : t('yes')}</Button>
                <Button  variant="contained" style={{backgroundColor: '#ef9a9a'}} onClick={() => onClose(false, action)}>{noLabel ? noLabel : t('no')}</Button>
            </DialogActions>
        </Dialog>
    );
}
